import { Link } from 'react-router-dom';
import { Heart, Users } from 'lucide-react';
import { Card, CardContent } from '@/components/ui';
import { trackEvent } from '@/lib/analytics';
import { getAcquisitionEventParams } from '@/lib/acquisition';

export function RegisterSelectPage() {
  return (
    <div className="animate-fade-in">
      {/* Header */}
      <div className="text-center mb-8">
        <h2 className="text-2xl font-heading-luxury text-luxury-dark mb-2">
          新規登録
        </h2>
        <p className="text-neutral-600">
          あなたの目的を選択してください
        </p>
      </div>

      {/* Options */}
      <div className="space-y-4">
        {/* Donee option */}
        <Link
          to="/register/donee"
          state={{ registerStartTracked: true }}
          onClick={() => trackEvent('donee_register_start', {
            source: 'role_select',
            ...getAcquisitionEventParams(),
          })}
        >
          <Card className="hover:border-rose-gold transition-all duration-300 cursor-pointer group">
            <CardContent className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-rose-gold/10 flex items-center justify-center group-hover:bg-rose-gold/20 transition">
                <Heart className="w-7 h-7 text-rose-gold" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-luxury-dark mb-1">
                  ドニー（レシピエント）
                </h3>
                <p className="text-sm text-neutral-600">
                  精子提供を受けたい方
                </p>
              </div>
              <div className="text-xs text-white bg-rose-gold px-3 py-1 rounded-full">
                無料
              </div>
            </CardContent>
          </Card>
        </Link>

        {/* Donor option */}
        <Link to="/register/donor">
          <Card className="hover:border-copper transition-all duration-300 cursor-pointer group">
            <CardContent className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-copper/10 flex items-center justify-center group-hover:bg-copper/20 transition">
                <Users className="w-7 h-7 text-copper" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-luxury-dark mb-1">
                  ドナー（提供者）
                </h3>
                <p className="text-sm text-neutral-600">
                  精子を提供したい方
                </p>
              </div>
              <div className="text-xs text-neutral-600 bg-neutral-100 px-3 py-1 rounded-full">
                無料・審査あり
              </div>
            </CardContent>
          </Card>
        </Link>
      </div>

      {/* Info */}
      <div className="mt-8 p-4 bg-neutral-100 rounded-lg">
        <p className="text-sm text-neutral-600 leading-relaxed">
          ドナー登録には本人確認書類の提出と審査が必要です。
          審査には通常2〜3営業日かかります。
        </p>
      </div>

      {/* Login link */}
      <p className="text-center mt-6 text-neutral-600">
        すでにアカウントをお持ちの方は{' '}
        <Link to="/login" className="text-copper font-medium hover:underline">
          ログイン
        </Link>
      </p>
    </div>
  );
}
